export default __webpack_public_path__ + "static/B0214-0034a41ec67a813a3c82de5adf206ad5.png";